// Local Variables
const CONTENT_ITEM = 'contentItem';
const TERM = 'term';
const AUTHOR = 'author';

// Module Exports
export { AUTHOR, CONTENT_ITEM, TERM };
